import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const LinkedinIcon = (props: IconProps) => (
  <ChakraIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.70689 0.914551L21.4554 0.914551C22.3529 0.914551 23.0826 1.62507 23.0826 2.501V21.3273C23.0826 22.2032 22.3529 22.9145 21.4554 22.9145L2.70689 22.9145C1.81141 22.9145 1.08337 22.2032 1.08337 21.3273L1.08337 2.501C1.08337 1.62507 1.81141 0.914551 2.70689 0.914551ZM5.8769 7.72782C6.92027 7.72782 7.76809 6.88001 7.76809 5.83582C7.76809 4.79082 6.92027 3.94301 5.8769 3.94301C4.8315 3.94301 3.98572 4.79082 3.98572 5.83582C3.98572 6.88001 4.8315 7.72782 5.8769 7.72782ZM4.37045 19.7445H7.45388V9.27113L4.37045 9.27113L4.37045 19.7445ZM13.1808 9.28421L10.5563 9.28421L10.5563 19.7258L13.6694 19.7258L13.6694 14.4679C13.6694 14.3971 13.6692 14.3264 13.6689 14.2561C13.6641 12.9653 13.6597 11.7716 15.27 11.7716C16.8723 11.7716 16.8684 13.2064 16.8651 14.3971C16.8649 14.4505 16.8648 14.5033 16.8648 14.5555V19.7258H19.9691V13.9028C19.9691 11.0758 19.6171 8.90227 16.313 8.90227C14.7257 8.90227 13.6612 9.77208 13.2257 10.5979H13.1808V9.28421Z"
      fill="currentColor"
    />
  </ChakraIcon>
);
